import { GetterTree } from "vuex";
import { MapLayersState } from "./types";
import { RootState } from "../types";
import MapLayerItemTypes from "@/constants/MapLayerItemTypes";

export const getters: GetterTree<MapLayersState, RootState> = {
	getMapLayers: state => state.MapLayer,
	getMapLayersForGroup: state => state.MapLayersForGroup,
	getMapLayersBounds: state => state.MapLayersBounds,
	getManualRaiseMarkerPosition: state => state.ManualRaiseMarkerPosition,
	getManualRaiseSelectedLayer: state => state.ManualRaiseSelectedLayer,
	getSortedElevations: state => state.MapLayer.elevations.slice().sort((a, b) => a - b),
	getMapItemIcons: state => state.MapItemIcons,
	getBrokenMapItemIcons: state => state.BrokenMapItemIcons,
	getLayersHidden: state => state.LayersHidden,
	getElevation: state => state.Elevation,
	getZoomLevel: state => state.ZoomLevel,
	getSelectedMapElevation: state => state.MapSelectedElevation,
	getMapLayersItemTypes: state => state.MapLayersItemTypes,
	getEditableMapLayerItemTypes: state =>
		state.MapLayersItemTypes.filter(f => f.mapLayerItemTypeID !== MapLayerItemTypes.Guard)
};
